export default "__VITE_ASSET__d7a79938__"